import { useEffect } from 'react'
import { CookiesProvider } from 'react-cookie'
import { RouterProvider } from 'react-router-dom'
import { createQueryClient } from '~/components/Utils/QueryClient'
import { ReactQueryDevtools } from '~/components/Utils/ReactQueryDevtools'

import { QueryClientProvider } from '@tanstack/react-query'

import { AppRoutes } from './AppRoutes'
import './License'
import { CanalyTheme } from './Theme'

export function App() {
  const client = createQueryClient()

  // #root の zoom 適用後にレイアウトが確定するため、初期描画後に resize を通知して
  // ApexChart 等の自動サイズ計測を確定値で再実行させる
  useEffect(() => {
    const raf = requestAnimationFrame(() => {
      window.dispatchEvent(new Event('resize'))
    })
    const timer = setTimeout(() => window.dispatchEvent(new Event('resize')), 300)
    return () => {
      cancelAnimationFrame(raf)
      clearTimeout(timer)
    }
  }, [])

  return (
    <QueryClientProvider client={client}>
      <ReactQueryDevtools />
      <CookiesProvider>
        {/* <AuthProvider> */}
        <CanalyTheme>
          <RouterProvider router={AppRoutes()} />
        </CanalyTheme>
        {/* </AuthProvider> */}
      </CookiesProvider>
    </QueryClientProvider>
  )
}
